module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-technology.301bd610.png";